var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { registerClass, currySC } from '@food/css-manager';
import { Button } from '@food/ui/build/dist/src/Button';
var styleClass = registerClass(function (t, sc) { return "\n\ttext-align: center;\n\t\n\t." + sc('main-text') + " {\n\t\tmargin-bottom: " + t.font.baseSize + "px;\n\t}\n\t"; });
var sc = currySC(styleClass);
export var RememberSocialStep = function (_a) {
    var t = _a.t, proceed = _a.proceed, socialType = _a.socialType;
    return (React.createElement(React.Fragment, null,
        React.createElement("h2", null, t(templateObject_1 || (templateObject_1 = __makeTemplateObject(["remember switch to social title"], ["remember switch to social title"])))),
        React.createElement("section", { className: styleClass },
            React.createElement("div", { className: sc('main-text'), dangerouslySetInnerHTML: {
                    __html: t(templateObject_2 || (templateObject_2 = __makeTemplateObject(["remember social account html"], ["remember social account html"]))),
                } }),
            React.createElement("div", { className: sc('main-text') }, t(templateObject_3 || (templateObject_3 = __makeTemplateObject(["social login type associated"], ["social login type associated"]))),
                ":",
                socialType),
            React.createElement(Button, { label: t(templateObject_4 || (templateObject_4 = __makeTemplateObject(["proceed"], ["proceed"]))), onClick: function () { return proceed(); } }))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=RememberSocialStep.js.map